{
  "title": "A Judge Shows Up in the COI Overlap Alert List",
  "description": "How to diagnose and resolve a judge/submission pair appearing in the Review Progress page's conflict-of-interest overlap alert list.",
  "headings": ["Symptom", "Most Common Causes", "Diagnosis", "Expected Result", "Still Stuck"],
  "symptom": "On the Review Progress page's conflict-of-interest alert list, a judge and a submission appear together, meaning that judge has declared a conflict but still holds an active assignment for that submission.",
  "causes": [
    "The assignment was created before that judge declared the conflict, and declaring it afterward didn't automatically remove the existing assignment",
    "A competition admin manually assigned that submission to the judge despite already knowing about a declared conflict"
  ],
  "diagnosis": [
    {
      "title": "Step 1",
      "description": "Go to the Review Progress page and look at the conflict-of-interest list below the table; confirm the judge, team, and stated reason for that row."
    },
    {
      "title": "Step 2",
      "description": "Check that row's \"Source\" column to see whether it was self-declared by the judge or manually recorded by an admin — either source can produce an overlap with an existing assignment."
    },
    {
      "title": "Step 3",
      "description": "Decide whether you already know who the replacement judge should be: if so, use Reassign in one step; if not, use Cancel only first."
    }
  ],
  "resolution": "If you already have a replacement judge in mind, click \"Reassign\" on that row of the COI list, pick the new judge from the dropdown, and confirm — the server re-validates the conflict against the new judge before creating the new assignment and removing the overlapping one, all without a trip to the Assignments tab. If you don't have a replacement picked yet, click \"Cancel only\" instead (a reason is required); the overlapping assignment turns Cancelled, and you can assign a replacement later from the Assignments tab. If you don't have permission to do either yourself, contact a competition admin with judge-governance permission to handle it.",
  "stillStuck": [
    "Competition name",
    "Judge name / email",
    "Affected submission name or code",
    "When and how the conflict was declared",
    "Screenshot (the Review Progress page's COI alert list)"
  ],
  "doNotProvide": ["Passwords", "Verification codes", "Tokens"],
  "nextSteps": "Still unsure how to proceed? See \"Reading Review Progress and COI Alerts\" to review what each column on this page means."
}
